module.exports = __webpack_public_path__ + "assets/32216ba8618a2e7ae9f8d194e5936274.svg";